import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Sidenav/sgds-sidenav-item";
import { register } from "../../utils/ce-registry";

register("sgds-sidenav-item", Component);

export default createComponent({
  react: React,
  tagName: "sgds-sidenav-item",
  elementClass: Component,
  events: {
    onSgdsToggle: "sgds-toggle",
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide"
  }
});
